'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

var _reactBootstrap = require('react-bootstrap');

var _components2 = require('components');

require('./style.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    VoiceCodeView: {
        displayName: 'VoiceCodeView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/VoiceCode/default/VoiceCodeView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var VoiceCodeView = _wrapComponent('VoiceCodeView')((_temp = _class = function (_Component) {
    (0, _inherits3.default)(VoiceCodeView, _Component);

    function VoiceCodeView() {
        (0, _classCallCheck3.default)(this, VoiceCodeView);
        return (0, _possibleConstructorReturn3.default)(this, (VoiceCodeView.__proto__ || (0, _getPrototypeOf2.default)(VoiceCodeView)).apply(this, arguments));
    }

    (0, _createClass3.default)(VoiceCodeView, [{
        key: 'render',
        value: function render() {
            var lang = this.props.lang;

            var retry_in = lang['store.timer.retry'] + ' ';
            var seconds = ' ' + lang['store.timer.sec'] + ' ';

            if (this.props.alert) {
                this.props.showAlert();
            }

            return _react3.default.createElement(
                _reactBootstrap.FormGroup,
                null,
                _react3.default.createElement(
                    'div',
                    { className: 'voice_wrap text-center' },
                    this.props.currentTime > 0 ? _react3.default.createElement(
                        'p',
                        { id: 'voice_call_time_wrap', className: 'active' },
                        retry_in,
                        _react3.default.createElement(
                            'span',
                            { id: 'voice_call_time active' },
                            this.props.currentTime
                        ),
                        seconds
                    ) : _react3.default.createElement(
                        _components2.Preloader,
                        { classNames: 'mini_preload', preload: this.props.preloader },
                        _react3.default.createElement(
                            'a',
                            { id: 'get_voice_call', href: '#', onClick: this.props.onCallbackVoice },
                            lang['store.voice_code.request_voice_call']
                        )
                    )
                )
            );
        }
    }]);
    return VoiceCodeView;
}(_react2.Component), _class.propTypes = {
    currentTime: _react2.PropTypes.number,
    lang: _react2.PropTypes.object
}, _temp));

exports.default = VoiceCodeView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/VoiceCode/default/VoiceCodeView.jsx
// module id = 1788
// module chunks = 0